import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSchool: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="school, building"><path d="M21.25 19.25V8.75H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M17.25 19.25V4.75H6.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 8.75H2.75V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M22.25 19.25H1.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9.75 19.25V14.75H14.25V19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSchool;
